<mat-card>
  <mat-card-header class="between">
    <mat-card-title>Samples</mat-card-title>

    <div class="links">
      <cpr-sample-generation-button />

      @if (count > 0) {
        <a mat-flat-button routerLink="cutting-points">
          <mat-icon>content_cut</mat-icon>
          <span>View Cutting Points</span>
        </a>
        <a mat-flat-button routerLink="samples/allocate">
          <mat-icon>checklist</mat-icon>
          <span>Set PCI Colour & Allocate Samples</span>
        </a>
        <a mat-flat-button routerLink="samples">
          <mat-icon>grid_on</mat-icon>
          <span>View Analysis Overview</span>
        </a>
      }
    </div>
  </mat-card-header>

  <mat-card-content>
    <div>
      <mat-checkbox (change)="onMySamplesToggle($event)" [(ngModel)]="onlyMySamples">
        Only show samples allocated to you
      </mat-checkbox>
    </div>
    <table
      mat-table
      [dataSource]="dataSource$"
      matSort
      matSortDisableClear
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="listDropped($event)"
    >
      <ng-container matColumnDef="sampleNo">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            Sample no.
          }
        </th>
        <td mat-cell *matCellDef="let item">{{ item.sampleNo }}</td>
      </ng-container>

      <ng-container matColumnDef="userId">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            Analyst
          }
        </th>
        <td mat-cell *matCellDef="let item">
          <app-user-avatar [userId]="item.userId" />
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          @if (!isLoading) {
            Status
          }
        </th>
        <td mat-cell *matCellDef="let item">
          <cpr-sample-status [sample]="item" />
        </td>
      </ng-container>

      <ng-container matColumnDef="chlorophyllIndex">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            PCI Colour
          }
        </th>
        <td mat-cell *matCellDef="let item">
          <app-pci-colour [value]="item.chlorophyllIndex" />
        </td>
      </ng-container>

      <ng-container matColumnDef="sampleLatitude">
        <th mat-header-cell *matHeaderCellDef>
          @if (!isLoading) {
            Latitude
          }
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.coordinates[1] | coord: 'lat' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sampleLongitude">
        <th mat-header-cell *matHeaderCellDef>
          @if (!isLoading) {
            Longitude
          }
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.coordinates[0] | coord: 'lng' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="sampleMidpointDate">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            UTC Midpoint Date
          }
        </th>
        <td mat-cell *matCellDef="let item">
          {{ item.sampleMidpointDate | date: 'medium' : 'UTC' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="button">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let item" style="text-align: right">
          @if (!item.submittedAt && item.userId === user?._id) {
            <button mat-button>Data Entry</button>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headings"></tr>
      <tr
        mat-row
        class="clickable"
        [class.hidden]="isLoading"
        *matRowDef="let row; columns: headings"
        [routerLink]="['samples', row._id]"
      ></tr>

      <tr class="mat-row" *matNoDataRow [hidden]="isLoading">
        <td class="mat-cell" [attr.colspan]="headings.length">
          <!-- prettier-ignore -->
          <span>{{ onlyMySamples ? 'No matching data' : 'Unavailable until generated from tow log'}}</span>
        </td>
      </tr>
    </table>

    @if (isLoading) {
      <suvo-bi-skeleton-table-rows [rowCount]="15" [columnWidths]="widths" />
    }
  </mat-card-content>
</mat-card>
